import { render, staticRenderFns } from "./TimeLineAvaliacoes.vue?vue&type=template&id=27d21b1d&scoped=true&"
import script from "./TimeLineAvaliacoes.vue?vue&type=script&lang=js&"
export * from "./TimeLineAvaliacoes.vue?vue&type=script&lang=js&"
import style0 from "./TimeLineAvaliacoes.vue?vue&type=style&index=0&id=27d21b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d21b1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCol,VRow,VTimeline,VTimelineItem})
